import {
  Icon3dCubeSphere,
  IconBrandOffice,
  IconCategory,
  IconDashboard,
  IconEdit,
  IconEyeCog,
  IconFile,
  IconList,
  IconMicrophone2,
  IconMoodCog,
  IconPlane,
  IconPlus,
  IconSchool,
  IconScreenshot,
  IconSettings,
  IconVideo,
} from "@tabler/icons-react";

import { MenuItemProps } from "./@types/NavigationTypes";
import { Session } from "next-auth";

export const NavigationContent = ({ role }: Session): MenuItemProps[] => [
  // {
  //   props: {
  //     title: "DashBoard",
  //     icon: <IconDashboard />,
  //     dropdown: false,
  //     path: "/"
  //   },
  // },
  {
    props: {
      title: "Equipamentos",
      icon: <Icon3dCubeSphere />,
      dropdown: true,
      submenu: [
        {
          props: {
            title: "Novo",
            icon: <IconPlus />,
            path: "/entities/product/create",
          },
        },
        {
          props: {
            title: "Equipamentos",
            path: "/entities/product/",
            icon: <IconList />,
          },
        },
        {
          props: {
            title: "Pagina Geral",
            path: "/entities/products-page/",
            icon: <IconList />,
          },
        },
      ],
    },
  },
  {
    props: {
      title: "Academia",
      icon: <IconSchool />,
      dropdown: true,
      submenu: [
        {
          props: {
            title: "Página",
            icon: <IconEdit />,
            path: "/entities/page/academia",
          },
        },
        {
          props: {
            title: "Webnars",
            icon: <IconVideo />,
            path: "/entities/webnar",
          },
        },
        {
          props: {
            title: "Eventos",
            path: "/entities/event/",
            icon: <IconMicrophone2 />,
          },
        },
      ],
    },
  },
  {
    props: {
      title: "Trabalhe Conosco",
      icon: <IconBrandOffice />,
      dropdown: true,
      submenu: [
        {
          props: {
            title: "Página",
            icon: <IconEdit />,
            path: "/entities/page/trabalhe-conosco",
          },
        },
        {
          props: {
            title: "Colaboradores",
            icon: <IconVideo />,
            path: "/entities/staf",
          },
        },
        {
          props: {
            title: "Banners Estágio",
            icon: <IconScreenshot />,
            path: "/entities/trainee-banner",
          },
        },
      ],
    },
  },
  {
    props: {
      title: "Notas de Aplicação",
      icon: <IconList />,
      path: "/entities/notes",
    },
  },
  {
    props: {
      title: "Categorias",
      icon: <IconCategory />,
      dropdown: true,
      submenu: [
        {
          props: {
            title: "Páginas de Categoria",
            icon: <IconEdit />,
            path: "/entities/category-page/",
          },
        },
        {
          props: {
            title: "Taxonomias",
            icon: <IconVideo />,
            path: "/taxonomy",
          },
        },
      ],
    },
  },
  // {
  //   props: {
  //     title: "Configurações",
  //     icon: <IconSettings />,
  //     path: "/configurations",
  //   },
  // },
];

export const ExternalContent: Array<MenuItemProps> = [];
